import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from '@mui/material';
import { useOrganizationLayoutQuery } from 'generated/graphql';
import {
  HeaderNavbar,
  RoundedPane
} from 'modules';
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useParams
} from 'react-router-dom';



export const OrganizationLayout = () => {
  const params = useParams<{
    userId: string;
    organizationId: string;
  }>();
  const location = useLocation();
  const navigate = useNavigate();
  const { data, loading } = useOrganizationLayoutQuery({
  });

  if (!params.organizationId) {
    const org = data?.loggedInUser?.person.currentOrganization;
    if (!loading && org) {
      return (
        <Navigate to={org.id} />
      );
    } else if (!loading) {
      return (
        <div>
          No organizations found
        </div>
      );
    } else {
      return (
        <div>
          Loading
        </div>
      );
    }
  } else if (params.organizationId) {
    if (!loading) {
      const org = data?.loggedInUser?.person.memberships.some((o) => o.organization.id === params.organizationId);
      if (!org && location.pathname !== '/account') {
        return <Navigate to='/account' />;
      }
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        paddingX: '1.5rem'
      }}
    >
      <HeaderNavbar.FC />

      <Box
        display='flex'
        columnGap='1rem'
      >
        <RoundedPane.FC>
          <List>
            <ListItem>
              <ListItemButton
                onClick={() => navigate(`/account/${params.organizationId}/settings`)}
                selected={location.pathname === `/account/${params.organizationId}/settings`}
              >
                <ListItemText primary='Organization' />
              </ListItemButton>
            </ListItem>

            <ListItem>
              <ListItemButton
                onClick={() => navigate(`/account/${params.organizationId}/subscription`)}
                selected={location.pathname.endsWith('subscription')}
              >
                <ListItemText primary='Subscription' />
              </ListItemButton>
            </ListItem>

            <ListItem>
              <ListItemButton
                onClick={() => navigate(`/account/${params.organizationId}/users`)}
                selected={location.pathname.endsWith('/users')}
              >
                <ListItemText primary='Users' />
              </ListItemButton>
            </ListItem>
          </List>
        </RoundedPane.FC>

        <Box flex='3 1 0'>
          <RoundedPane.FC>
            <Outlet />
          </RoundedPane.FC>
        </Box>
      </Box>
    </Box>
  );
};
